import React from 'react'
import { Outlet } from 'react-router-dom'

const Signup = () => {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default Signup